import {IApiModel} from 'app/original-models/api-model.interface';

export class Subscription implements IApiModel<Subscription> {
    plan: string;
    planName: string;
    nextBillingAt: string;
    portalSessionAccessUrl: string;
    status: string;
    permission: any;
    signupTracked: boolean;
    teammembers: any;

    constructor(init?: Partial<Subscription>) {
        Object.assign(this, init);
    }

    getApiModel(): any {

        return {
            plan: this.plan,
            next_billing_at: this.nextBillingAt,
            portal_session_access_url: this.portalSessionAccessUrl,
            teammembers: this.teammembers
        }
    }

    setFromApiModel(apiModel: any): this {
        this.plan = apiModel.plan;
        this.planName = apiModel.plan_name;
        this.status = apiModel.status;
        this.nextBillingAt = apiModel.next_billing_at;
        this.portalSessionAccessUrl = apiModel.portal_session_access_url;
        this.permission = {};
        this.signupTracked  = apiModel.ftue;
        if (!isNaN(apiModel.companies)) {
            this.permission.companies = apiModel.companies;
        }
        return this;
    }
}
